import styled from '@emotion/styled';
import { Row, Column, Divider, device, typography } from '@landsbankinn/ui';
import React from 'react';

const Host = styled.div``;

const Content = styled.div`
  display: flex;
  flex-flow: column nowrap;

  margin-bottom: 60px;

  @media ${device.desktop} {
    margin-bottom: 0;
    height: 100%;
  }
`;

const Title = styled.div`
  ${typography.h3}
  margin-bottom: 14px;
`;
const Copy = styled.div`
  margin-top: 20px;
  margin-bottom: 40px;
  max-width: 292px;
`;

const Action = styled.div`
  margin-top: auto;
  a {
    color: ${(props) => props.theme.shades.ternary5};

    &:hover {
      opacity: 0.8;
    }
  }
`;

const Childs = styled.div`
  display: flex;
  flex-flow: row wrap;

  @media ${device.tablet} {
    flex-flow: row nowrap;
  }

  > * {
    margin-bottom: 50px;

    @media ${device.mobile} {
      width: calc(50% - 10px);
      margin-left: 20px;

      &:nth-child(odd) {
        margin-left: 0;
      }
    }

    @media ${device.tablet} {
      width: calc(25% - 15px);
      margin-bottom: 0;
      &:nth-child(odd) {
        margin-left: 20px;
      }
      &:first-child {
        margin-left: 0;
      }
    }
  }
`;

interface IPodcast {
  title: string | null;
  text: React.ReactNode;
  link: React.ReactNode;
  children: React.ReactNode;
}

export const Podcast = ({ title, text, link, children }: IPodcast) => {
  return (
    <Host>
      <Row>
        <Column
          lg={{
            width: 4 / 12,
          }}
        >
          <Content>
            <Title>{title}</Title>
            <Divider />
            <Copy>{text}</Copy>
            <Action>{link}</Action>
          </Content>
        </Column>
        <Column
          lg={{
            width: 8 / 12,
          }}
        >
          <Childs>{children}</Childs>
        </Column>
      </Row>
    </Host>
  );
};
